import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';
import './Payment.css';

function Payment() {
  const { cartItems, setFormData } = useCart();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    setFormData(data);
    navigate('/shipping');
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="navbar">
          <div className="logo">
            <img src="/logo.png" alt="logo" />
          </div>
          <div className="brand-name">Cozy Fang</div>
          <nav>
            <ul className="menu">
              <li className="home"><Link to="/">Home</Link></li>
              <li><Link to="/store">Store</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>
        </div>
      </header>
      
      <div className="payment">
        <form className="payment-form" onSubmit={handleSubmit}>
          <label>
            Imię:
            <input type="text" name="firstName" placeholder="Wpisz swoje imię" required />
          </label>
          <label>
            Nazwisko:
            <input type="text" name="lastName" placeholder="Wpisz swoje nazwisko" required />
          </label>
          <label>
            Miasto:
            <input type="text" name="city" placeholder="Wpisz swoje miasto" required />
          </label>
          <label>
            Ulica:
            <input type="text" name="street" placeholder="Wpisz swoją ulicę" required />
          </label>
          <label>
            Numer domu:
            <input type="text" name="houseNumber" placeholder="Wpisz numer domu" required />
          </label>
          <label>
            Kod pocztowy:
            <input type="text" name="postalCode" placeholder="Wpisz kod pocztowy" required />
          </label>
          <label>
            Numer telefonu:
            <input type="tel" name="phoneNumber" placeholder="Wpisz numer telefonu" required />
          </label>
          <label>
            Email:
            <input type="email" name="email" placeholder="Wpisz swój email" required />
          </label>
          <button type="submit" id="zatwierdz"><span>Zatwierdź</span></button>
        </form>

        <div className="cart-summary" style={{ float: 'right', width: '30%' }}>
          <h2>Twój koszyk</h2>
          <div className="cart-items">
            {cartItems.length > 0 ? (
              cartItems.map(item => (
                <div key={item.id} className="product-tile">
                  <img src={item.image || '/placeholder.jpg'} alt={item.name} />
                  <div className="product-info">
                    <h3>{item.name}</h3>
                    <p>Cena: {item.price} zł</p>
                    <p>Ilość: {item.quantity}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>Twój koszyk jest pusty.</p>
            )}
          </div>
          {cartItems.length > 0 && (
            <p><strong>Razem:</strong> Cena: {cartItems.reduce((total, item) => total + item.price * item.quantity, 0)} zł</p>
          )}
        </div>
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid black', margin: '0' }} />

      <div className="Footer">
        <img src="/logo.png" alt="Logo" />
      </div>
      <div className="Footer-bar">
        <div className="footer-left">
          COZY FANG 2025 <br />
          WSZELKIE PRAWA ZASTRZEŻONE
        </div>
        <div className="footer-icons">
          <img src="/ig.png" alt="Instagram" />
          <img src="/fb.png" alt="Facebook" />
          <img src="/yt.png" alt="YouTube" />
        </div>
        <div className="footer-right">
          <a href="/regulamin">REGULAMIN</a>
          <a href="/polityka-prywatnosci">POLITYKA PRYWATNOŚCI</a>
        </div>
      </div>
    </div>
  );
}

export default Payment;
